import React from 'react';

const DefaultPage = () => {
    return (
        <div>
            <h2>Welcome to mobilepoint dashboard</h2>
            <img src="https://i.ibb.co/mHWZzbm/Welcome.png" style={{ width: '50%' }} alt='' />
        </div>
    );
};

export default DefaultPage;